import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {ValidateService} from '../validate.service';
import {NgbDateStruct, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CommonSlickgridComponent} from '../common-slickgrid/common-slickgrid.component';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Editors, FieldType, Filters, Formatters, OnEventArgs} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {THIS_EXPR} from '@angular/compiler/src/output/output_ast';
import {ConfigService} from '../config.service';

@Component({
    selector: 'app-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit, OnDestroy {
    searchTerm: FormControl = new FormControl();
    displayed = true;
    name: string;
    keyPerson: string;
    keyEmail: string;
    keyMobile: string;
    cliAddr: string;
    dateStart = '';
    hourStart: any;
    hourEnd: any;
    dateEnd = '';
    spocPerson: string;
    spocEmail: string;
    spocMobile: string;
    totalData = 0;
    show: boolean;
    selected: number;
    zoneSelected: string;
    gridData = [];
    zones: any;
    slideChecked = false;
    // id = 2;
    days = [];
    prefix: string;
    sunChck: boolean;
    sunHourStart: any;
    sunHourEnd: any;
    monChck: boolean;
    tueChck: boolean;
    monHourStart: any;
    monHourEnd: any;
    tueHourStart: Object;
    tueHourEnd: Object;
    wedChck: boolean;
    wedHourStart: any;
    wedHourEnd: any;
    thurChck: boolean;
    thurHourEnd: any;
    thurHourStart: any;
    friChck: boolean;
    friHourStart: any;
    friHourEnd: any;
    satChck: boolean;
    satHourStart: any;
    satHourEnd: any;
    hourChecked = false;
    grpCheck: boolean;
    sub_client: number;


    private respObject: any;
    displayData: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    isLoading = false;
    personChecked = false;
    @ViewChild('content1') private content1;
    private modalReference: NgbModalRef;
    private selectedId: number;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    clientCode: string;
    private baseFlag: any;
    private adminAuth: Subscription;
    uploadpath = '';
    dataLoaded: boolean;
    showSearch = true;
    isLoading1 = false;
    searchData: FormControl = new FormControl();
    clientSelected: any;
    clients: any;
    code: string;
    fileUploadUrl: string;
    uploadButtonName = 'Upload File';
    attachment = [];
    uploadSuccessMessage: string;
    logoName: string;
    attachMsg: string;
    formData: any;
    logoUrl: string;


    hours = [];
    mins = [];
    sunHoursStart: any;
    sunMinsStart: any;
    sunHoursEnd: any;
    sunMinsEnd: any;
    monHoursStart: any;
    monMinsStart: any;
    monHoursEnd: any;
    monMinsEnd: any;
    tueHoursStart: any;
    tueMinsStart: any;
    tueHoursEnd: any;
    tueMinsEnd: any;
    wedHoursStart: any;
    wedMinsStart: any;
    wedHoursEnd: any;
    wedMinsEnd: any;
    thurHoursStart: any;
    thurMinsStart: any;
    thurHoursEnd: any;
    thurMinsEnd: any;
    friHoursStart: any;
    friMinsStart: any;
    friHoursEnd: any;
    friMinsEnd: any;
    satHoursStart: any;
    satMinsStart: any;
    satHoursEnd: any;
    satMinsEnd: any;
    hoursStart: any;
    minsStart: any;
    hoursEnd: any;
    minsEnd: any;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService, private validateService: ValidateService,
                private config: ConfigService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        console.log(JSON.stringify(item));

                    }
                    break;
                case 'delete':
                    console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteClient({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.searchTerm.valueChanges.subscribe(
            zone => {
                this.isLoading = true;
                this._rest.searchZone(zone).subscribe((res1) => {
                    this.respObject = res1;
                    this.isLoading = false;
                    if (this.respObject.success) {

                        this.isError = false;
                        this.zones = this.respObject.details;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isLoading = false;
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            });


        this.searchData.valueChanges.subscribe(
            name => {
                this.isLoading1 = true;
                this._rest.searchAllClient(name, this.clientId).subscribe((res1) => {
                    this.respObject = res1;
                    this.isLoading1 = false;
                    if (this.respObject.success) {
                        this.clients = this.respObject.details;
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.isLoading1 = false;
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            });
    }

    ngOnInit() {
        this.logoUrl = 'https://ifix-uat.s3.amazonaws.com/tcs_icc_poc/asset/tcs_logo_1597238668391.jpeg';
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        // this.messageService.setGridWidth(4300);
        this.sunChck = false;
        this.monChck = false;
        this.tueChck = false;
        this.wedChck = false;
        this.thurChck = false;
        this.friChck = false;
        this.satChck = false;
        this.grpCheck = false;
        this.sub_client = 0;
        for (let i = 0; i < 25; i++) {
            if (i <= 9) {
                this.hours.push('0' + i);
            } else {
                this.hours.push('' + i);
            }
        }

        for (let i = 0; i < 60; i++) {
            if (i <= 9) {
                this.mins.push('0' + i);
            } else {
                this.mins.push('' + i);
            }
        }


        this.displayData = {
            pageName: 'Maintain Client',
            openModalButton: 'Create Client',
            searchModalButton: 'Search',
            breadcrumb: 'ClientCreation',
            folderName: 'All Clients',
            tabName: 'Clients'
        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'edit',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.editIcon,
                minWidth: 30,
                maxWidth: 30,
                onCellClick: (e: Event, args: OnEventArgs) => {
                    console.log(args.dataContext);
                    this.selectedId = args.dataContext.id;
                    this.name = args.dataContext.NAME;
                    this.cliAddr = args.dataContext.cliAddr;
                    this.keyPerson = args.dataContext.keyPerson;
                    this.cliAddr = args.dataContext.cliAddr;
                    this.keyEmail = args.dataContext.keyEmail;
                    this.keyMobile = args.dataContext.keyMobile;
                    this.spocPerson = args.dataContext.spocName;
                    this.spocEmail = args.dataContext.spocEmail;
                    this.spocMobile = args.dataContext.spocNumber;
                    // this.zoneSelected = args.dataContext.zone;
                    this.sunChck = args.dataContext.sunChck;
                    this.monChck = args.dataContext.monChck;
                    this.tueChck = args.dataContext.tueChck;
                    this.wedChck = args.dataContext.wedChck;
                    this.thurChck = args.dataContext.thurChck;
                    this.friChck = args.dataContext.friChck;
                    this.satChck = args.dataContext.satChck;
                    this.keyMobile = args.dataContext.keyMobile;
                    this.uploadpath = args.dataContext.upload_path;
                    this.logoName = args.dataContext.logo;
                    this.logoUrl = this.config.UPLOAD_PATH_BASE + 'tcs_icc_poc/asset/' + this.logoName;
                    // this.spocPerson = args.dataContext.spocPerson;
                    if (this.sunChck) {
                        this.sunHourStart = args.dataContext.sunHourStart.split(':');
                        this.sunHoursStart = this.sunHourStart[0];
                        this.sunMinsStart = this.sunHourStart[1];
                        this.sunHourEnd = args.dataContext.sunHourEnd.split(':');
                        this.sunHoursEnd = this.sunHourEnd[0];
                        this.sunMinsEnd = this.sunHourEnd[1];


                        // this.sunHourStart = new Date(this.hourToTimestamp(args.dataContext.sunHourStart));
                        // this.sunHourEnd = new Date(this.hourToTimestamp(args.dataContext.sunHourEnd));

                    } else {

                        this.sunHoursStart = this.hours[0];
                        this.sunMinsStart = this.mins[0];
                        this.sunHoursEnd = this.hours[0];
                        this.sunMinsEnd = this.mins[0];


                        // this.sunHourStart = 0;
                        // this.sunHourEnd = 0;
                    }
                    if (this.monChck) {
                        this.monHourStart = args.dataContext.monHourStart.split(':');
                        this.monHoursStart = this.monHourStart[0];
                        this.monMinsStart = this.monHourStart[1];
                        this.monHourEnd = args.dataContext.monHourEnd.split(':');
                        this.monHoursEnd = this.monHourEnd[0];
                        this.monMinsEnd = this.monHourEnd[1];
                    } else {
                        this.monHoursStart = this.hours[0];
                        this.monMinsStart = this.mins[0];
                        this.monHoursEnd = this.hours[0];
                        this.monMinsEnd = this.mins[0];

                    }
                    if (this.tueChck) {
                        this.tueHourStart = args.dataContext.tueHourStart.split(':');
                        this.tueHoursStart = this.tueHourStart[0];
                        this.tueMinsStart = this.tueHourStart[1];
                        this.tueHourEnd = args.dataContext.tueHourEnd.split(':');
                        this.tueHoursEnd = this.tueHourEnd[0];
                        this.tueMinsEnd = this.tueHourEnd[1];


                        // this.tueHourStart = new Date(this.hourToTimestamp(args.dataContext.tueHourStart));
                        // this.tueHourEnd = new Date(this.hourToTimestamp(args.dataContext.tueHourEnd));
                    } else {
                        // this.tueHourStart = 0;
                        // this.tueHourEnd = 0;

                        this.tueHoursStart = this.hours[0];
                        this.tueMinsStart = this.mins[0];
                        this.tueHoursEnd = this.hours[0];
                        this.tueMinsEnd = this.mins[0];

                    }
                    if (this.wedChck) {
                        this.wedHourStart = args.dataContext.wedHourStart.split(':');
                        this.wedHoursStart = this.wedHourStart[0];
                        this.wedMinsStart = this.wedHourStart[1];
                        this.wedHourEnd = args.dataContext.wedHourEnd.split(':');
                        this.wedHoursEnd = this.wedHourEnd[0];
                        this.wedMinsEnd = this.wedHourEnd[1];


                        // this.wedHourStart = new Date(this.hourToTimestamp(args.dataContext.wedHourStart));
                        // this.wedHourEnd = new Date(this.hourToTimestamp(args.dataContext.wedHourEnd));
                    } else {
                        this.wedHoursStart = this.hours[0];
                        this.wedMinsStart = this.mins[0];
                        this.wedHoursEnd = this.hours[0];
                        this.wedMinsEnd = this.mins[0];
                    }
                    if (this.thurChck) {

                        this.thurHourStart = args.dataContext.thurHourStart.split(':');
                        this.thurHoursStart = this.thurHourStart[0];
                        this.thurMinsStart = this.thurHourStart[1];
                        this.thurHourEnd = args.dataContext.thurHourEnd.split(':');
                        this.thurHoursEnd = this.thurHourEnd[0];
                        this.thurMinsEnd = this.thurHourEnd[1];

                        // this.thurHourStart = new Date(this.hourToTimestamp(args.dataContext.thurHourStart));
                        // this.thurHourEnd = new Date(this.hourToTimestamp(args.dataContext.thurHourEnd));
                    } else {

                        this.thurHoursStart = this.hours[0];
                        this.thurMinsStart = this.mins[0];
                        this.thurHoursEnd = this.hours[0];
                        this.thurMinsEnd = this.mins[0];

                        // this.thurHourStart = 0;
                        // this.thurHourEnd = 0;
                    }
                    if (this.friChck) {
                        this.friHourStart = args.dataContext.friHourStart.split(':');
                        this.friHoursStart = this.friHourStart[0];
                        this.friMinsStart = this.friHourStart[1];
                        this.friHourEnd = args.dataContext.friHourEnd.split(':');
                        this.friHoursEnd = this.friHourEnd[0];
                        this.friMinsEnd = this.friHourEnd[1];


                        // this.friHourStart = new Date(this.hourToTimestamp(args.dataContext.friHourStart));
                        // this.friHourEnd = new Date(this.hourToTimestamp(args.dataContext.friHourEnd));
                    } else {


                        this.friHoursStart = this.hours[0];
                        this.friMinsStart = this.mins[0];
                        this.friHoursEnd = this.hours[0];
                        this.friMinsEnd = this.mins[0];

                        // this.friHourStart = 0;
                        // this.friHourEnd = 0;
                    }
                    if (this.satChck) {


                        this.satHourStart = args.dataContext.satHourStart.split(':');
                        this.satHoursStart = this.satHourStart[0];
                        this.satMinsStart = this.satHourStart[1];
                        this.satHourEnd = args.dataContext.satHourEnd.split(':');
                        this.satHoursEnd = this.satHourEnd[0];
                        this.satMinsEnd = this.satHourEnd[1];

                        // this.satHourStart = new Date(this.hourToTimestamp(args.dataContext.satHourStart));
                        // this.satHourEnd = new Date(this.hourToTimestamp(args.dataContext.satHourEnd));
                    } else {


                        this.satHoursStart = this.hours[0];
                        this.satMinsStart = this.mins[0];
                        this.satHoursEnd = this.hours[0];
                        this.satMinsEnd = this.mins[0];

                        // this.satHourStart = 0;
                        // this.satHourEnd = 0;
                    }
                    this.dateStart = args.dataContext.startDate;
                    // console.log("aaaaaaaaa"+this.dateStart);
                    if (args.dataContext.endDate === null) {
                        this.slideChecked = !this.slideChecked;
                    } else {
                        this.slideChecked = false;
                        this.dateEnd = args.dataContext.endDate;
                    }
                    this.attachMsg = '';
                    this.attachment = [];
                    this.modalReference = this.modalService.open(this.content1, {});
                    this.modalReference.result.then((result) => {
                    }, (reason) => {

                    });
                }
            },
            // {id: 'id', name: 'Client Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'name', name: 'Client Name', field: 'NAME', minWidth: 100, sortable: true, filterable: true
            }, {
                id: 'clientcode', name: 'Client Code', field: 'clientCode', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'cliAddr', name: 'Client Address', field: 'cliAddr', minWidth: 50, sortable: true, filterable: true
            },
            {
                id: 'keyPerson', name: 'Key Person', field: 'keyPerson', minWidth: 40, sortable: true, filterable: true
            },
            {
                id: 'keyEmail', name: 'Key Person Email', field: 'keyEmail', minWidth: 50, sortable: true, filterable: true
            },
            {
                id: 'keyMobile', name: 'Key Person Mobile', field: 'keyMobile', minWidth: 50, sortable: true, filterable: true
            },
            {
                id: 'zone', name: 'Zone', field: 'zone', sortable: true, minWidth: 50, filterable: true
            },
            {
                id: 'spocName', name: 'Spoc Name', field: 'spocName', minWidth: 50, sortable: true, filterable: true
            },
            {
                id: 'spocMobile', name: 'Spoc Mobile', field: 'spocMobile', minWidth: 50, sortable: true, filterable: true
            },
            {
                id: 'spocEmail', name: 'Spoc Email', field: 'spocEmail', minWidth: 50, sortable: true, filterable: true
            },
            {
                id: 'startDate',
                name: 'Activation Start',
                field: 'startDate',
                sortable: true,
                minWidth: 100,
                filterable: true
            },
            {
                id: 'endDate',
                name: 'Activation End',
                field: 'endDate',
                sortable: true,
                minWidth: 100,
                filterable: true
            },
            {
                id: 'sunChck', name: 'Sunday', field: 'sunChck', sortable: true, formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, filterable: true, minWidth: 40
            },
            {
                id: 'sunHourStart',
                name: 'Sunday Hour Start',
                field: 'sunHourStart',
                minWidth: 100,
                sortable: true,
                filterable: true
            },
            {
                id: 'sunHourEnd', name: 'Sunday Hour End', field: 'sunHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'monChck',
                name: 'Monday',
                field: 'monChck',
                sortable: true,
                filterable: true,
                formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                },
                minWidth: 40
            },
            {
                id: 'monHourStart', name: 'Monday Hour Start', field: 'monHourStart', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'monHourEnd', name: 'Monday Hour End', field: 'monHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'tueChck', name: 'Tuesday', field: 'tueChck', sortable: true, filterable: true, formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, minWidth: 40
            },
            {
                id: 'tueHourStart', name: 'Tuesday Hour Start', field: 'tueHourStart', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'tueHourEnd', name: 'Tuesday Hour End', field: 'tueHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'wedChck', name: 'Wednesday', field: 'wedChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40
            },
            {
                id: 'wedHourStart', name: 'Wednesday Hour Start', field: 'wedHourStart', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'wedHourEnd', name: 'Wednesday Hour End', field: 'wedHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'thurChck', name: 'Thursday', field: 'thurChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40
            },
            {
                id: 'thurHourStart', name: 'Thursday Hour Start', field: 'thurHourStart', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'thurHourEnd', name: 'Thursday Hour End', field: 'thurHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'friChck', name: 'Friday', field: 'friChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40
            },
            {
                id: 'friHourStart', name: 'Friday Hour Start', field: 'friHourStart', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'friHourEnd', name: 'Friday Hour End', field: 'friHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'satChck', name: 'Saturday', field: 'satChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,
                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40
            },
            {
                id: 'satHourStart', name: 'Saturday Hour Start', field: 'satHourStart', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'satHourEnd', name: 'Saturday Hour End', field: 'satHourEnd', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'uploadPath', name: 'Upload Path', field: 'upload_path', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'subClient', name: 'Sub Client', field: 'sub_client', minWidth: 100, sortable: true, filterable: true
            },
            {
                id: 'logo', name: 'Logo', field: 'logo', minWidth: 100, sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
        // this.zones = [{id: 0, zone: 'Select Time Zone'}, {id: 1, zone: 'Asia/Taipei'}, {id: 2, zone: 'Asia/Dubai'},
        //   {id: 3, zone: 'Australia/Perth'}];
        this.days = [{id: 0, day: 'Sun', checked: false}, {id: 1, day: 'Mon', checked: false}, {id: 2, day: 'Tue', checked: false}, {
            id: 3,
            day: 'Wed',
            checked: false
        }, {id: 4, day: 'Thur', checked: false}, {
            id: 5,
            day: 'Fri', checked: false
        }, {id: 6, day: 'Sat', checked: false}];
    }

    onPageLoad() {
        this.formData = {
            'clientId': 1,
            'createdBy': this.messageService.getUserId(),
            'type': 'type'
            // 'user_id': this.messageService.getUserId()
        };
        this.getTableData();
    }

    get selectedOptions() {
        return this.days
            .filter(opt => opt.checked)
            .map(opt => opt.id);
    }

    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            // this.name = '';
            // this.keyPerson = '';
            // this.keyEmail = '';
            // this.keyMobile = '';
            // this.cliAddr = '';
            // this.spocPerson = '';
            // this.spocEmail = '';
            // this.spocMobile = '';
            // this.dateStart = '';
            // this.dateEnd = '';
            // this.slideChecked = false;
            this.reassignData();
            this.modalService.open(content, {}).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    searchModal(scarch_content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.code = '';
            this.clientSelected = '';
            this.modalService.open(scarch_content).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getDetails() {
        for (let i = 0; i < this.clients.length; i++) {
            if (this.clients[i].NAME === this.clientSelected) {
                this.code = this.clients[i].clientCode;
            }
        }
    }

    search() {
        const data = [];
        for (let i = 0; i < this.clients.length; i++) {
            if (this.clients[i].NAME === this.clientSelected) {
                data.push(this.clients[i]);
            }
        }
        this.page_no = 1;
        this.messageService.setTotalData(data.length);
        this.messageService.setGridData(data);
    }


    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    reassignData() {
        this.name = '';
        this.keyPerson = '';
        this.clientCode = '';
        this.keyEmail = '';
        this.keyMobile = '';
        this.cliAddr = '';
        this.uploadpath = '';
        this.spocPerson = '';
        this.spocEmail = '';
        this.spocMobile = '';
        this.dateStart = '';
        this.dateEnd = '';
        this.slideChecked = false;
        this.sunChck = false;
        this.monChck = false;
        this.tueChck = false;
        this.wedChck = false;
        this.thurChck = false;
        this.friChck = false;
        this.satChck = false;
        this.hoursStart = this.hours[0];
        this.hoursEnd = this.hours[0];
        this.minsStart = this.mins[0];
        this.minsEnd = this.mins[0];


        this.sunHourStart = '00:00';
        this.sunHourEnd = '00:00';
        this.monHourStart = '00:00';
        this.monHourEnd = '00:00';
        this.tueHourStart = '00:00';
        this.tueHourEnd = '00:00';
        this.wedHourStart = '00:00';
        this.wedHourEnd = '00:00';
        this.thurHourStart = '00:00';
        this.thurHourEnd = '00:00';
        this.friHourStart = '00:00';
        this.friHourEnd = '00:00';
        this.satHourStart = '00:00';
        this.satHourEnd = '00:00';


        this.sunHoursStart = this.hours[0];
        this.sunMinsStart = this.mins[0];
        this.sunHoursEnd = this.hours[0];
        this.sunMinsEnd = this.mins[0];
        this.monHoursStart = this.hours[0];
        this.monMinsStart = this.mins[0];
        this.monHoursEnd = this.hours[0];
        this.monMinsEnd = this.mins[0];
        this.tueHoursStart = this.hours[0];
        this.tueMinsStart = this.mins[0];
        this.tueHoursEnd = this.hours[0];
        this.tueMinsEnd = this.mins[0];
        this.wedHoursStart = this.hours[0];
        this.wedMinsStart = this.mins[0];
        this.wedHoursEnd = this.hours[0];
        this.wedMinsEnd = this.mins[0];
        this.thurHoursStart = this.hours[0];
        this.thurMinsStart = this.mins[0];
        this.thurHoursEnd = this.hours[0];
        this.thurMinsEnd = this.mins[0];
        this.friHoursStart = this.hours[0];
        this.friMinsStart = this.mins[0];
        this.friHoursEnd = this.hours[0];
        this.friMinsEnd = this.mins[0];
        this.satHoursStart = this.hours[0];
        this.satMinsStart = this.mins[0];
        this.satHoursEnd = this.hours[0];
        this.satMinsEnd = this.mins[0];

        this.hourChecked = false;
        this.personChecked = false;
        this.zoneSelected = '';
        this.grpCheck = false;
        this.attachMsg = '';
        this.days = [{id: 0, day: 'Sun', checked: false}, {id: 1, day: 'Mon', checked: false}, {id: 2, day: 'Tue', checked: false}, {
            id: 3,
            day: 'Wed',
            checked: false
        }, {id: 4, day: 'Thur', checked: false}, {
            id: 5,
            day: 'Fri', checked: false
        }, {id: 6, day: 'Sat', checked: false}];
    }

    greaterfunc(data) {
        if (this.sunChck === true && (data.sunHourStart >= data.sunHourEnd)) {
            return false;
        } else if (this.monChck === true && (data.monHourStart >= data.monHourEnd)) {
            return false;
        } else if (this.tueChck === true && (data.tueHourStart >= data.tueHourEnd)) {
            return false;
        } else if (this.wedChck === true && (data.wedHourStart >= data.wedHourEnd)) {
            return false;
        } else if (this.thurChck === true && (data.thurHourStart >= data.thurHourEnd)) {
            return false;
        } else if (this.satChck === true && (data.satHourStart >= data.satHourEnd)) {
            return false;
        } else if (this.friChck === true && (data.friHourStart >= data.friHourEnd)) {
            return false;
        } else {
            return true;
        }
    }

    onFileComplete(data: any) {
        console.log('file data==========' + JSON.stringify(data));
        this.logoName = data.changedName;
        if (data.success) {
            this.attachment.push({originalName: data.fileName, fileName: data.changedName});
            if (this.attachment.length > 1) {
                this.attachMsg = this.attachment.length + ' files uploaded successfully';
            } else {
                this.attachMsg = this.attachment.length + ' file uploaded successfully';
            }
        }
    }

    onFileError(msg: string) {
        this.notifier.notify('error', msg);
    }

    save() {


        this.hourStart = this.hoursStart + ':' + this.minsStart;
        this.hourEnd = this.hoursEnd + ':' + this.minsEnd;
        if (this.sunChck) {
            this.sunHourStart = this.sunHoursStart + ':' + this.sunMinsStart;
            this.sunHourEnd = this.sunHoursEnd + ':' + this.sunMinsEnd;

        } else {
            this.sunHourStart = '00:00';
            this.sunHourEnd = '00:00';

        }
        if (this.monChck) {
            this.monHourStart = this.monHoursStart + ':' + this.monMinsStart;
            this.monHourEnd = this.monHoursEnd + ':' + this.monMinsEnd;

        } else {
            this.monHourStart = '00:00';
            this.monHourEnd = '00:00';

        }
        if (this.tueChck) {
            this.tueHourStart = this.tueHoursStart + ':' + this.tueMinsStart;
            this.tueHourEnd = this.tueHoursEnd + ':' + this.tueMinsEnd;

        } else {
            this.tueHourStart = '00:00';
            this.tueHourEnd = '00:00';

        }

        if (this.wedChck) {
            this.wedHourStart = this.wedHoursStart + ':' + this.wedMinsStart;
            this.wedHourEnd = this.wedHoursEnd + ':' + this.wedMinsEnd;
        } else {
            this.wedHourStart = '00:00';
            this.wedHourEnd = '00:00';

        }
        if (this.thurChck) {
            this.thurHourStart = this.thurHoursStart + ':' + this.thurMinsStart;
            this.thurHourEnd = this.thurHoursEnd + ':' + this.thurMinsEnd;

        } else {
            this.thurHourStart = '00:00';
            this.thurHourEnd = '00:00';

        }
        if (this.friChck) {
            this.friHourStart = this.friHoursStart + ':' + this.friMinsStart;
            this.friHourEnd = this.friHoursEnd + ':' + this.friMinsEnd;

        } else {
            this.friHourStart = '00:00';
            this.friHourEnd = '00:00';

        }
        if (this.satChck) {
            this.satHourStart = this.satHoursStart + ':' + this.satMinsStart;
            this.satHourEnd = this.satHoursEnd + ':' + this.satMinsEnd;

        } else {
            this.satHourStart = '00:00';
            this.satHourEnd = '00:00';

        }

        // console.log(this.grpCheck);
        if (this.grpCheck === true) {
            this.sub_client = 1;
        } else {
            this.sub_client = 0;
        }
        if (this.hourChecked) {
            console.log(typeof this.hourStart, this.hourStart);
            for (let i = 0; i < this.selectedOptions.length; i++) {
                if (this.selectedOptions[i] === 0) {
                    this.sunChck = true;
                    this.sunHourStart = this.hourStart;
                    this.sunHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 1) {
                    this.monChck = true;
                    this.monHourStart = this.hourStart;
                    this.monHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 2) {
                    this.tueChck = true;
                    this.tueHourStart = this.hourStart;
                    this.tueHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 3) {
                    this.wedChck = true;
                    this.wedHourStart = this.hourStart;
                    this.wedHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 4) {
                    this.thurChck = true;
                    this.thurHourStart = this.hourStart;
                    this.thurHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 5) {
                    this.friChck = true;
                    this.friHourStart = this.hourStart;
                    this.friHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 6) {
                    this.satChck = true;
                    this.satHourStart = this.hourStart;
                    this.satHourEnd = this.hourEnd;
                }
            }
        }
        let zoneId = 0;
        for (let i = 0; i < this.zones.length; i++) {
            if (this.zones[i].name === this.zoneSelected) {
                zoneId = this.zones[i].id;
            }
        }
        const data = {
            name: this.name,
            clientCode: this.clientCode,
            keyPerson: this.keyPerson,
            keyEmail: this.keyEmail,
            keyMobile: this.keyMobile,
            cliAddr: this.cliAddr,
            zone: zoneId,
            uploadpath: this.uploadpath,
            spocName: this.spocPerson,
            spocNumber: this.spocMobile,
            spocEmail: this.spocEmail,
            startDate: this.dateStart,
            endDate: this.dateEnd,
            // prefix: this.prefix,
            sunChck: this.sunChck,
            sunHourStart: this.sunHourStart,
            sunHourEnd: this.sunHourEnd,
            monChck: this.monChck,
            monHourStart: this.monHourStart,
            monHourEnd: this.monHourEnd,
            tueChck: this.tueChck,
            tueHourStart: this.tueHourStart,
            tueHourEnd: this.tueHourEnd,
            wedChck: this.wedChck,
            wedHourStart: this.wedHourStart,
            wedHourEnd: this.wedHourEnd,
            thurChck: this.thurChck,
            thurHourStart: this.thurHourStart,
            thurHourEnd: this.thurHourEnd,
            friChck: this.friChck,
            friHourStart: this.friHourStart,
            friHourEnd: this.friHourEnd,
            satChck: this.satChck,
            satHourStart: this.satHourStart,
            satHourEnd: this.satHourEnd,
            sub_client: this.sub_client,
            logo: this.logoName
        };
        console.log('save data=', JSON.stringify(data));
        // console.log('blank field check', !this.messageService.isBlankField(data));
        console.log('select options=', this.selectedOptions.length);
        // console.log('hourchecked', this.hourChecked);

        if (!this.messageService.isBlankField(data) || (this.selectedOptions.length > 0 && this.hourChecked === true && data.zone !== 0 && this.uploadpath !== '' && this.dateStart !== '' && (this.dateEnd !== '' || this.slideChecked === true))) {
            if (this.validateService.ValidateEmail(data.keyEmail) && this.validateService.ValidateEmail(data.spocEmail)
                && this.validateService.ValidatePhoneno(data.keyMobile) && this.validateService.ValidatePhoneno(data.spocNumber)) {
                if (this.greaterfunc(data)) {

                    this._rest.addClient(data).subscribe((res) => {
                        // console.log("update done")
                        this.respObject = res;
                        if (this.respObject.success) {
                            this.isError = false;
                            const id = this.respObject.clientId;
                            this.nextOffset = 0;
                            this.page_no = 0;
                            this.getTableData();
                            this.reassignData();
                        } else {
                            this.isError = true;
                            this.errorMessage = this.respObject.errorMessage;
                        }
                    }, (err) => {
                        this.isError = true;
                        this.errorMessage = this.messageService.SERVER_ERROR;
                    });
                } else {
                    this.isError = true;
                    this.errorMessage = this.messageService.WORKING_TIME_ERROR;
                }
            } else {
                this.isError = true;
                this.errorMessage = this.validateService.EmailOrPhoneFormatError;
            }
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }


    update() {
        // console.log(this.grpCheck);

        if (this.sunChck) {
            this.sunHourStart = this.sunHoursStart + ':' + this.sunMinsStart;
            this.sunHourEnd = this.sunHoursEnd + ':' + this.sunMinsEnd;

        } else {
            this.sunHourStart = '00:00';
            this.sunHourEnd = '00:00';

        }
        if (this.monChck) {
            this.monHourStart = this.monHoursStart + ':' + this.monMinsStart;
            this.monHourEnd = this.monHoursEnd + ':' + this.monMinsEnd;

        } else {
            this.monHourStart = '00:00';
            this.monHourEnd = '00:00';

        }
        if (this.tueChck) {
            this.tueHourStart = this.tueHoursStart + ':' + this.tueMinsStart;
            this.tueHourEnd = this.tueHoursEnd + ':' + this.tueMinsEnd;

        } else {
            this.tueHourStart = '00:00';
            this.tueHourEnd = '00:00';

        }

        if (this.wedChck) {
            this.wedHourStart = this.wedHoursStart + ':' + this.wedMinsStart;
            this.wedHourEnd = this.wedHoursEnd + ':' + this.wedMinsEnd;
        } else {
            this.wedHourStart = '00:00';
            this.wedHourEnd = '00:00';

        }
        if (this.thurChck) {
            this.thurHourStart = this.thurHoursStart + ':' + this.thurMinsStart;
            this.thurHourEnd = this.thurHoursEnd + ':' + this.thurMinsEnd;

        } else {
            this.thurHourStart = '00:00';
            this.thurHourEnd = '00:00';

        }
        if (this.friChck) {
            this.friHourStart = this.friHoursStart + ':' + this.friMinsStart;
            this.friHourEnd = this.friHoursEnd + ':' + this.friMinsEnd;

        } else {
            this.friHourStart = '00:00';
            this.friHourEnd = '00:00';

        }
        if (this.satChck) {
            this.satHourStart = this.satHoursStart + ':' + this.satMinsStart;
            this.satHourEnd = this.satHoursEnd + ':' + this.satMinsEnd;

        } else {
            this.satHourStart = '00:00';
            this.satHourEnd = '00:00';

        }


        if (this.grpCheck === true) {
            this.sub_client = 1;
        } else {
            this.sub_client = 0;
        }
        if (this.hourChecked) {
            // console.log(typeof this.hourStart, this.hourStart);
            for (let i = 0; i < this.selectedOptions.length; i++) {
                if (this.selectedOptions[i] === 0) {
                    this.sunChck = true;
                    this.sunHourStart = this.hourStart;
                    this.sunHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 1) {
                    this.monChck = true;
                    this.monHourStart = this.hourStart;
                    this.monHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 2) {
                    this.tueChck = true;
                    this.tueHourStart = this.hourStart;
                    this.tueHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 3) {
                    this.wedChck = true;
                    this.wedHourStart = this.hourStart;
                    this.wedHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 4) {
                    this.thurChck = true;
                    this.thurHourStart = this.hourStart;
                    this.thurHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 5) {
                    this.friChck = true;
                    this.friHourStart = this.hourStart;
                    this.friHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 6) {
                    this.satChck = true;
                    this.satHourStart = this.hourStart;
                    this.satHourEnd = this.hourEnd;
                }
            }
        }
        // let zoneId = 0;
        // for (let i = 0; i < this.zones.length; i++) {
        //     if (this.zones[i].name === this.zoneSelected) {
        //         zoneId = this.zones[i].id;
        //     }
        // }
        const data = {
            id: this.selectedId,
            name: this.name,
            clientCode: this.clientCode,
            keyPerson: this.keyPerson,
            keyEmail: this.keyEmail,
            keyMobile: this.keyMobile,
            cliAddr: this.cliAddr,
            // zone: zoneId,
            uploadpath: this.uploadpath,
            spocName: this.spocPerson,
            spocNumber: this.spocMobile,
            spocEmail: this.spocEmail,
            startDate: this.dateStart,
            endDate: this.dateEnd,
            // prefix: this.prefix,
            sunChck: this.sunChck,
            sunHourStart: this.sunHourStart,
            sunHourEnd: this.sunHourEnd,
            monChck: this.monChck,
            monHourStart: this.monHourStart,
            monHourEnd: this.monHourEnd,
            tueChck: this.tueChck,
            tueHourStart: this.tueHourStart,
            tueHourEnd: this.tueHourEnd,
            wedChck: this.wedChck,
            wedHourStart: this.wedHourStart,
            wedHourEnd: this.wedHourEnd,
            thurChck: this.thurChck,
            thurHourStart: this.thurHourStart,
            thurHourEnd: this.thurHourEnd,
            friChck: this.friChck,
            friHourStart: this.friHourStart,
            friHourEnd: this.friHourEnd,
            satChck: this.satChck,
            satHourStart: this.satHourStart,
            satHourEnd: this.satHourEnd,
            sub_client: this.sub_client,
            logo: this.logoName
        };
        if (!this.messageService.isBlankField(data) || (this.uploadpath !== '' && this.dateStart !== '' && (((this.dateEnd !== '' || this.dateEnd !== null) && this.slideChecked === false) || this.slideChecked === true))) {
            if (this.validateService.ValidateEmail(data.keyEmail) && this.validateService.ValidateEmail(data.spocEmail)
                && this.validateService.ValidatePhoneno(data.keyMobile) && this.validateService.ValidatePhoneno(data.spocNumber)) {
                if (this.greaterfunc(data)) {
                    this._rest.updateClient(data).subscribe((res) => {
                        // console.log('save data==================>>>>>', JSON.stringify(data));
                        this.respObject = res;
                        if (this.respObject.success) {
                            this.isError = false;
                            this.nextOffset = 0;
                            this.page_no = 0;
                            this.getTableData();
                            // this.reassignData();
                            this.attachMsg = '';
                            this.attachment = [];
                            this.modalReference.close();
                            this.notifier.notify('success', 'Update Successfully');
                        } else {
                            this.isError = true;
                            this.errorMessage = this.respObject.errorMessage;
                        }
                    }, (err) => {
                        this.isError = true;
                        this.errorMessage = this.messageService.SERVER_ERROR;
                    });
                } else {
                    this.isError = true;
                    this.errorMessage = this.messageService.WORKING_TIME_ERROR;
                }
            } else {
                this.isError = true;
                this.errorMessage = this.validateService.EmailOrPhoneFormatError;
            }
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;

        }

    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getClientDetails(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, function (err) {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    slideChange() {
        this.slideChecked = !this.slideChecked;
    }

    hourChange() {
        this.hourChecked = !this.hourChecked;
    }

    timeFormat(date) {
        // console.log(date);
        if (date !== null && date !== 0 && date !== undefined) {
            const d = new Date(date);
            const hour = d.getHours();
            const min = d.getMinutes();
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return nHour + ':' + nMin;
        } else {
            return '00:00';
        }
    }

    keyPersonChecked() {
        this.personChecked = !this.personChecked;
        if (this.personChecked) {
            this.spocPerson = this.keyPerson;
            this.spocEmail = this.keyEmail;
            this.spocMobile = this.keyMobile;
        } else {
            this.spocPerson = '';
            this.spocEmail = '';
            this.spocMobile = '';
        }
    }

    hourToTimestamp(hour) {
        hour = hour + '';
        // console.log('hour=', hour);
        const hr = hour.substring(0, 2);
        const min = hour.substring(3, 5);
        // console.log(hr, min);
        const newDate = new Date().setHours(0, 0, 0, 0);
        // console.log('newDate', newDate);
        const hrInMilli = hr * 60 * 60 * 1000;
        const minInMilli = min * 60 * 1000;
        const total = newDate + hrInMilli + minInMilli;
        return total;
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
